// ../../ConfigFiles/multilingual/VocabDays.js
const VocabWeekdays = [
  // Spanish
  ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
  // English
  ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
  // German
  ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
];

export function get_weekdays(lan) {
  return VocabWeekdays[lan] || VocabWeekdays[0];
}
